import { ICurrencyList } from './../hooks/useCurrencies';
import { createContext } from 'react';

export const Context = createContext<{
    currencies: ICurrencyList,
    products: any[],
    theme?: 'light' | 'dark',
    metrics?: {
        [key in string]: {

        }
    }
}>({
    currencies: {},
    products: [],
    metrics: {},
    theme: 'light'
});